module.exports = "/fonts/assistant-latin.woff2?2b1b7f916b516d8bbbe38247c5cc5d41";